import React from 'react'
import NotificationPreferenceForm, {
    NotificationPreferenceFormState,
} from 'components/forms/account/notificationPreferenceForm'
import { Trans } from 'react-i18next'
import SubmitButton from 'components/common/submitButton'
import { Typography } from '@material-ui/core'
import AuthenticateContent from 'components/layouts/components/authenticateContent'
import AuthenticateActions from 'components/layouts/components/authenticateActions'
import clsx from 'clsx'
import { useStyles } from './notificationPreferenceView.css'

interface Props {
    onSubmit: (values: NotificationPreferenceFormState) => void
    onCancel: () => void
    inProgress: boolean
    initialValues: NotificationPreferenceFormState
    hideDays: boolean
    hideNotification: boolean
    withBottomTabs?: boolean
}

const NotificationPreferenceView: React.FC<Props> = ({ onCancel, withBottomTabs, ...formData }) => {
    const classes = useStyles()
    return (
        <NotificationPreferenceForm {...formData}>
            {(content, actions) => (
                <>
                    <AuthenticateContent>
                        <Typography variant="h1" className={classes.title}>
                            <Trans i18nKey="views.account.notifications" />
                        </Typography>
                        {content}
                    </AuthenticateContent>
                    <AuthenticateActions>
                        <SubmitButton variant="contained" onClick={onCancel}>
                            <Trans i18nKey="actions.previous" />
                        </SubmitButton>
                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                {...action}
                                className={clsx(action.className)}
                            />
                        ))}
                    </AuthenticateActions>
                </>
            )}
        </NotificationPreferenceForm>
    )
}

export default NotificationPreferenceView
